import { useState } from 'react'
import classNames from 'classnames'
import './GlossarySearch.scss'
import { ReactComponent as SearchIcon } from '../../../assets/svgs/search-icon.svg'

const GlossarySearch = ({ onSubmit, className }) => {
  const [searchTerm, setSearchTerm] = useState('')
  const [hasError, setHasError] = useState(false)
  const [hasSubmitted, setHasSubmitted] = useState(false)

  const handleChange = (event) => {
    setHasError(false)
    setSearchTerm(event.target.value)
  }

  const handleSubmit = (event) => {
    event.preventDefault()

    if (searchTerm.trim().length === 0 && !hasSubmitted) {
      setHasError(true)
      return
    }

    onSubmit(searchTerm)
    setHasSubmitted(true)
  }

  return (
    <form
      noValidate
      className={classNames('o-glossary-search', className)}
      onSubmit={handleSubmit}>
      <div className={'o-glossary-search__input-container'}>
        <label
          className="o-glossary-search__label u-visually-hidden"
          htmlFor="glossary-search">
          Start your search
        </label>
        <input
          type="search"
          className={classNames(
            'o-glossary-search__input',
            hasError ? 'o-glossary-search__input--invalid' : undefined
          )}
          placeholder="Start your search"
          id="glossary-search"
          name="glossary-search"
          onChange={handleChange}
          required
        />
        <button
          type="submit"
          className="o-glossary-search__button"
          aria-label="Search glossary">
          <SearchIcon className="o-glossary-search__button-icon" />
        </button>
      </div>
      {hasError && (
        <span role="alert" className="o-glossary-search__error-text">
          Please enter something in the search
        </span>
      )}
    </form>
  )
}

export default GlossarySearch
